import { render, staticRenderFns } from "./FeedClassifiedEntry.vue?vue&type=template&id=3351822b&scoped=true&"
import script from "./FeedClassifiedEntry.vue?vue&type=script&lang=ts&"
export * from "./FeedClassifiedEntry.vue?vue&type=script&lang=ts&"
import style0 from "./FeedClassifiedEntry.vue?vue&type=style&index=0&id=3351822b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3351822b",
  null
  
)

export default component.exports